import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

/**
 * Permet d'obtenir la date et l'heure avec comme caractère de séparation un _
 * entre chaque nombre
 * ex: 14/04/2019 9:13:57 => 14_04_2019_9_13_57
 * @returns {string}
 */
const getDateTimeNowWithUnderscores = () => {
    const hour = moment().format('HH_mm_ss');
    const date = moment().format('YYYY_MM_DD');
    return `${date}_${hour}`;
};
export default getDateTimeNowWithUnderscores;
